var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_left",
    clipPath: "url(#clip0_11368_68649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.83248 3.9913C4.37914 5.97797 6.66581 8.91797 6.66581 8.91797V12.2513C6.66581 12.9846 7.26581 13.5846 7.99914 13.5846C8.73248 13.5846 9.33248 12.9846 9.33248 12.2513V8.91797C9.33248 8.91797 11.6191 5.97797 13.1658 3.9913C13.5058 3.5513 13.1925 2.91797 12.6325 2.91797H3.35914C2.80581 2.91797 2.49248 3.5513 2.83248 3.9913Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11368_68649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.85817c30891681a40e317ff72a9bc1bb.svg";
export { ForwardRef as ReactComponent };